module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin@2x-624ee1b037d076ec8bcd3dea34bc9cad.png";